import { motion } from "framer-motion";

export function PageHero({ kicker, title, highlight, subtext, testid }) {
  return (
    <section data-testid={testid} className="relative pt-36 pb-16 sm:pb-20 overflow-hidden bg-grid-tech">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,136,0,0.08),transparent_55%)] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(0,176,255,0.06),transparent_50%)] pointer-events-none" />
      {/* decorative 3D orbit */}
      <div className="absolute -right-40 -top-24 w-[420px] h-[420px] pointer-events-none hidden lg:block">
        <div className="orbit-ring absolute inset-0 rounded-full border border-[#FF8800]/15" />
        <div className="orbit-ring-2 absolute inset-[70px] rounded-full border border-dashed border-[#00B0FF]/15" />
        <div className="absolute inset-[150px] rounded-full bg-[radial-gradient(circle,rgba(0,230,118,0.12),transparent_70%)]" />
      </div>
      <div className="absolute left-[4%] bottom-8 pointer-events-none hidden lg:block cube-wrap" data-testid="pagehero-cube">
        <div className="cube">
          <div className="cube-face" />
          <div className="cube-face" />
          <div className="cube-face" />
          <div className="cube-face" />
          <div className="cube-face" />
          <div className="cube-face" />
        </div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-mono-tech text-xs sm:text-sm tracking-[0.35em] text-[#00B0FF] uppercase mb-4"
        >
          {kicker}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75, delay: 0.1 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] max-w-4xl"
          data-testid={`${testid}-headline`}
        >
          <span className="text-gradient-hero">{title} </span>
          {highlight && <span className="text-gradient-saffron">{highlight}</span>}
        </motion.h1>
        {subtext && (
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, delay: 0.25 }}
            className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl"
            data-testid={`${testid}-subtext`}
          >
            {subtext}
          </motion.p>
        )}
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-b from-transparent to-[#06080E] pointer-events-none" />
    </section>
  );
}
